module.exports = __webpack_public_path__ + "img/3_132.50af211e.png";